const date = new Date();
export const nowDate =
  date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

export function setSavedValue(e) {
  let value = e.target.value;
  let name = e.target.name;
  if (value === "kLack" || value === "pLack") return "Insufficient";
  if (value === "kGood" || value === "pGood") return "Good";
  if (value === "kExcessive" || value === "pExcessive") return "Excessive";
  if (name === "files")
    return ["@" + e.target.files[0].name + ";type=" + e.target.files[0].type];
  else return value;
}

export function setSearchName(name, tabName) {
  let searchName =
    name === "Cancer Type" || (tabName === "Weight Guide" && name === "Treatment Stage")
      ? "lcategory"
      : (tabName === "Meal Guide" && name === "Treatment Stage") ||
        name === "Weight Change"
      ? "mcategory"
      : name === "Week and Period" || name === "Weight Status"
      ? "scategory"
      : name;

  return searchName;
}

// Meal guide select
export const foodOptions = [
  {
    id:1,
    label:"Cancer Type",
    options:["-", "All Cancers", "Colorectal Cancer", "Gastric Cancer"],
    type:"lcategory"
  },
  {
    id:2,
    label:"Treatment Stage",
    options:["-", "Under Treatment", "Maintenance", "Post-Surgery"],
    type:"mcategory"
  },
  {
     id:3,
     label:"Week and Period",
     options:  [
      "-",
      "Calorie Intake ≥ 110%",
      "90% ≤ Calorie Intake < 110%",
      "75% ≤ Calorie Intake < 90%",
      "50% < Calorie Intake < 75%",
      "Calorie Intake ≤ 50%",
      "Week 1",
      "Week 2",
      "Week 3",
      "Week 4",
      "Week 5",
      "Week 6",
      "Week 7",
      "Week 8",
      "Week 9",
      "Week 10",
      "Week 11",
      "Week 12",
    ],
    type:"scategory"
  }
];


// Weight guide select
export const weightOptions = [
  {
    id:1,
    label:"Treatment Stage",
    options:["-", "Under Treatment", "Maintenance"],
    type:"lcategory"
  },
  {
    id:2,
    label:"Weight Change",
    options:["-", "Weight Gain", "Slight Weight Change", "Moderate Weight Change", "Severe Weight Loss"],
    type:"mcategory"
  },
  {
    id:3,
    label:"Weight Status",
    options:["-", "Underweight", "Normal Weight", "Pre-Obese", "Obese"],
    type:"scategory"
  }
];

// Weight guide modal select
export const weightModalOptions = [
  {
    id:2,
    label:"Weight Change",
    options:["-", "Weight Gain", "Slight Weight Change", "Moderate Weight Change", "Severe Weight Loss"],
    type:"mcategory"
  },
  {
    id:3,
    label:"Weight Status",
    options:["-", "Underweight", "Normal Weight", "Pre-Obese", "Obese"],
    type:"scategory"
  }
];

// Symptom guide input text layout
export const symptomInputs = [
  {
    id:1,
    label:"Symptom Name",
    name:"symptom",
  },{
    id:2,
    label:"Term Explanation",
    name:"explanation",
  },{
    id:3,
    label:"Coping Summary",
    name:"copingSummary",
  },
]
